import React from "react";
;

const AboutMe = () => {
    return(
        <>
        <br></br>
    <h1>AboutMe</h1>
            <br></br>
            <p>I'm a full-stack developer passionate about building software users love and that solve big problems at scale. I have experience building reusable frontend components using React, managing complex application state using Redux, building backend services using Node.js and Express.js, and database management using PostgreSQL.</p>

            <p> My background in learning and remote collaboration gives me the resources to ask the right questions, get the right answers, and delivering on time. And now I can build full-stack web applications I'm a natural fit for a remote software development team.</p>

             <p>I am currently seeking full-stack or frontend development opportunities based in Seattle, WA or anywhere in the world if remote working is an option.</p>
            <br></br>
            <br></br>
        </>
    )
   
}
export default AboutMe;